import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {TaskModel} from "../../../models/task.model";
import {TaskStatusType} from "../../../types/taskStatus.type";
import * as _ from "lodash";
import {ActionReasonEntityEnum} from "../../../../action-reasons/enums/action-reason-entity.enum";
import {
  ActionReasonsDialogsServiceService
} from "../../../../action-reasons/services/action-reasons-dialogs-service.service";

require('./task-status-button.scss');
@Component({
  standalone: false,
  selector: 'app-task-status-button',
  templateUrl: './task-status-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskStatusButtonComponent implements OnInit, OnChanges {

  @Input() status: any;
  @Input() task: TaskModel;
  @Input() isSmall: boolean;
  @Input() prevTaskStatus: string;
  @Input() isHideTaskStatusTime: boolean;
  @Input() allowStatusChangeAction: boolean;
  @Output() onChange = new EventEmitter<any>();

  public taskStatusOptions: any;
  public actionable: any;
  public loading: any;
  public taskStatusTypes: typeof TaskStatusType = TaskStatusType;
  public actionableStatuses: TaskStatusType[];

  constructor(@Inject('taskRequests') private taskRequests, @Inject('tasksService') private tasksService, @Inject('actionReasonsDialogsService') private actionReasonsDialogsService,
              @Inject('deliveriesAlertsService') private deliveriesAlertsService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
              ) {
  }

  ngOnInit() {
    this.actionableStatuses = [
      TaskStatusType.CourierHeading,
      TaskStatusType.Assigned,
      TaskStatusType.CourierArrived,
      TaskStatusType.ContactNotAvailable
    ]
    this.initData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.status && !changes.status.isFirstChange() || changes.prevTaskStatus && !changes.prevTaskStatus.isFirstChange()) {
      this.initData();
    }
  }

  onChangeStatus(status, event) {
    if (status === this.taskStatusTypes.Canceled) {
      this._openCancelReason(event)
    } else if (status === this.taskStatusTypes.Assigned && (this.task.status === this.taskStatusTypes.CourierHeading || this.task.status === this.taskStatusTypes.CourierArrived)) {
      this._onOpenRevertActionDialog(event);
    } else {
      this._changeStatus(status);
    }
  }

  private _openCancelReason(event) {
    const entityType = this.task.taskSpec.purpose === 'Operation' ? ActionReasonEntityEnum.Operation : ActionReasonEntityEnum.Delivery;
    this.actionReasonsDialogsService.createCancelTaskReason([this.task.serviceId], event, false, 'Abort Task', [entityType])
      .then((payload) => {
        if (payload.cancelReason) {
          payload.cancelReason.taskId = this.task.id
          this._createCancelReason(payload.cancelReason, payload.relatedServicesIds)
        }
      })
      .catch((error) => {
        // if (error) {
        //   this.$log.error('Failed to create cancellation reason', error);
        // }
      })
  }

  private _onOpenRevertActionDialog(event) {
    const entityType = this.task.taskSpec.purpose === 'Operation' ? ActionReasonEntityEnum.Operation : ActionReasonEntityEnum.Delivery;
    this.actionReasonsDialogsService.createRevertTaskReason([this.task.serviceId], event, false, 'Abort Task', [entityType])
      .then((revertReason) => {
        this.tasksService.revertTaskStatus(this.task.id, revertReason);
      })
      .catch((error) => {
        // if (error) {
        //   this.$log.error('Failed to create revert reason', error);
        // }
      })
  }

  private _createCancelReason(cancelReason, relatedServicesIds?: string[]) {
    this.loading = true;
    this.taskRequests.changeTaskStatusToCancel(cancelReason, this.task.id, relatedServicesIds)
      .then((delivery) => {
        this.task = _.find(delivery.taskList, (t) => {
          return t.id === this.task.id;
        });
        this.status = this.task.status;
        // this.DeliveriesAlerts.changeTaskStatusSuccess(this.task);
        this.deliveriesAlertsService.cancelTaskSuccess(this.task);
        this.initData();
        this.cdr.detectChanges();
      })
      .catch((error) => {
        this.deliveriesAlertsService.cancelTaskError();
        // this.$log.error('Failed to change status @taskStatusButton@onChangeStatus', error);
      })
      .finally(() => {
        this.loading = false;
        this.cdr.detectChanges();
      })
  }

  private _changeStatus(status) {
    this.loading = true;
    this.taskRequests.changeTaskStatus(status, this.task)
      .then((tasks) => {
        // this.task = tasks[0];
        // this.status = tasks[0].status;
        this.deliveriesAlertsService.changeTaskStatusSuccess(tasks[0]);
        this.onChange.emit({task: tasks[0], status: tasks[0].status});
        // this.onChange({task: tasks[0], status: tasks[0].status})
        // this.$onInit();
      })
      .catch((error) => {
        this.deliveriesAlertsService.changeTaskStatusError(error);
        // this.$log.error('Failed to change status @taskStatusButton@onChangeStatus', error);
      })
      .finally(() => {
        this.loading = false;
        this.cdr.detectChanges();
      })
  }

  private initData() {
    this._setActions(this.status);
    // this.taskStatusOptions = [];
    this.actionable = false;
    this.loading = false;

    if (this.status) {
      this.actionable = _.indexOf(this.actionableStatuses, this.status) !== -1 &&
        (this.prevTaskStatus && this.prevTaskStatus === "CourierDeparted" || !this.prevTaskStatus);

    }
  }


  private _setActions(status) {
    this.taskStatusOptions = [];

    if (status === this.taskStatusTypes.Assigned ||
      status === this.taskStatusTypes.CourierDeparted ||
      status === this.taskStatusTypes.CourierArrived ||
      status === this.taskStatusTypes.CourierHeading ||
      status === this.taskStatusTypes.ContactNotAvailable ||
      status === this.taskStatusTypes.Canceled) {
      this._setTaskStatusOptions();
    }
  }

  private _setTaskStatusOptions() {
    this.taskStatusOptions = [
      this.taskStatusTypes.Assigned,
      this.taskStatusTypes.CourierHeading,
      this.taskStatusTypes.CourierArrived,
      this.taskStatusTypes.CourierDeparted
    ];
    if (this.task.taskType !== 'BundledStopover') {
      this.taskStatusOptions.push(this.taskStatusTypes.Canceled);
    }
  }

}
